var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 44.4,
    y1: 164.56,
    x2: 161.59,
    y2: 28.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M197.14,183.33l-83.33-83.33L197.14,16.67c3.81-3.81,3.81-10,0-13.81-3.81-3.81-10-3.81-13.81,0l-83.33,83.33L16.67,2.86C12.86-.95,6.68-.95,2.86,2.86s-3.81,10,0,13.81l83.33,83.33L2.86,183.33C1.03,185.16,0,187.64,0,190.24c0,5.39,4.37,9.76,9.77,9.76,2.59,0,5.08-1.03,6.91-2.86l83.33-83.33,83.33,83.33c1.83,1.83,4.32,2.86,6.91,2.86,2.59,0,5.08-1.03,6.91-2.86,3.81-3.81,3.81-10,0-13.81Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }));
};
export default SvgClose;